function EditIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect
        width="31"
        height="31"
        x="0.5"
        y="0.5"
        fill="#EDF5FF"
        rx="15.5"
      ></rect>
      <path
        fill="#1E87FF"
        d="M18 23.167h-4c-3.62 0-5.167-1.547-5.167-5.167v-4c0-3.62 1.547-5.166 5.167-5.166h1.333c.273 0 .5.226.5.5 0 .273-.227.5-.5.5H14c-3.074 0-4.167 1.093-4.167 4.166v4c0 3.073 1.093 4.167 4.167 4.167h4c3.073 0 4.166-1.094 4.166-4.167v-1.333c0-.274.227-.5.5-.5.274 0 .5.226.5.5V18c0 3.62-1.546 5.167-5.166 5.167z"
      ></path>
      <path
        fill="#1E87FF"
        d="M13.667 19.793c-.407 0-.78-.146-1.053-.413-.327-.327-.467-.8-.394-1.3l.287-2.007c.053-.386.306-.886.58-1.16L18.34 9.66c1.327-1.327 2.674-1.327 4 0 .727.727 1.053 1.467.987 2.207-.06.6-.38 1.186-.987 1.786l-5.253 5.254c-.273.273-.773.526-1.16.58l-2.007.286c-.086.02-.173.02-.253.02zm5.38-9.426l-5.254 5.253c-.126.127-.273.42-.3.593l-.286 2.007c-.027.193.013.353.113.453.1.1.26.14.454.114l2.006-.287c.174-.027.473-.173.594-.3l5.253-5.253c.433-.434.66-.82.693-1.18.04-.434-.186-.894-.693-1.407-1.067-1.067-1.8-.767-2.58.007z"
      ></path>
      <path
        fill="#1E87FF"
        d="M21.233 14.553a.43.43 0 01-.133-.02 5.291 5.291 0 01-3.64-3.64.506.506 0 01.346-.62c.267-.073.54.08.614.347a4.283 4.283 0 002.946 2.947c.267.073.42.353.347.62a.49.49 0 01-.48.366z"
      ></path>
      <rect
        width="31"
        height="31"
        x="0.5"
        y="0.5"
        stroke="#D0D5DD"
        rx="15.5"
      ></rect>
    </svg>
  );
}

export default EditIcon;
